<template>
    <div class="fd-nav">
        <div class="fd-nav-content">
            <div>
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
                    <el-menu-item index="Home" @click="link('/')">
                        <svg class="icon" aria-hidden="true">
                            <use v-show="activeIndex!='Home'" xlink:href="#icon-daohang-home1"></use>
                            <use v-show="activeIndex=='Home'" xlink:href="#icon-daohang-home2"></use>
                        </svg>{{$t('nav.Home')}}
                    </el-menu-item>
                    <el-menu-item index="Browse" @click="link('/browse/species')">
                        <svg class="icon" aria-hidden="true">
                            <use v-show="activeIndex!='Browse'" xlink:href="#icon-Browse1"></use>
                            <use v-show="activeIndex=='Browse'" xlink:href="#icon-Browse2"></use>
                        </svg>{{$t('nav.Browse')}}
                    </el-menu-item>
                    <el-menu-item index="Search" @click="link('/search')">
                        <svg class="icon" aria-hidden="true">
                            <use v-show="activeIndex!='Search'" xlink:href="#icon-Search1"></use>
                            <use v-show="activeIndex=='Search'" xlink:href="#icon-Search2"></use>
                        </svg>{{$t('nav.Search')}}
                    </el-menu-item>
                    <el-menu-item index="Standards" @click="link('/standards')">
                        <svg class="icon" aria-hidden="true">
                            <use v-show="activeIndex!='Standards'" xlink:href="#icon-Standards1"></use>
                            <use v-show="activeIndex=='Standards'" xlink:href="#icon-Standards2"></use>
                        </svg>{{$t('nav.Standards')}}
                    </el-menu-item>
                    <el-menu-item index="History" @click="link('/history')">
                        <svg class="icon" aria-hidden="true">
                            <use v-show="activeIndex!='History'" xlink:href="#icon-History1"></use>
                            <use v-show="activeIndex=='History'" xlink:href="#icon-History2"></use>
                        </svg>{{$t('nav.History')}}
                    </el-menu-item>
                    <el-menu-item index="Credit" @click="link('/credit')">
                        <svg class="icon" aria-hidden="true">
                            <use v-show="activeIndex!='Credit'" xlink:href="#icon-Credit1"></use>
                            <use v-show="activeIndex=='Credit'" xlink:href="#icon-Credit2"></use>
                        </svg>{{$t('nav.Credit')}}
                    </el-menu-item>
                    <el-submenu index="WDCMSOP">
                        <template slot="title">
                            <svg class="icon" aria-hidden="true">
                                <use v-show="activeIndex!='WDCMSOP-1' && activeIndex!='WDCMSOP-2' && activeIndex!='WDCMSOP-3'" xlink:href="#icon-a-WDCMSOP1"></use>
                                <use v-show="activeIndex=='WDCMSOP-1' || activeIndex=='WDCMSOP-2' || activeIndex=='WDCMSOP-3'" xlink:href="#icon-a-WDCMSOP2"></use>
                            </svg>{{$t('nav.WDCMSOP')}}
                        </template>
                        <el-menu-item index="WDCMSOP-1" @click="downsop1"> {{$t('nav.WDCMSOP')}}</el-menu-item>
                        <el-menu-item index="WDCMSOP-2" @click="downsop2"> {{$t('nav.WDCMProcedures')}}</el-menu-item>
                        <el-menu-item index="WDCMSOP-3" @click="link('/wdcmsop')"> {{$t('nav.CultureCollections')}}</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        };
    },
    props: {
        activeIndex: {
            type: String,
            default: "Home",
        },
    },

    watch: {
        $route: {
            handler(val) {
                this.activeIndex = this.$route.name;
            },
        },
    },
    methods: {
        link(path, val) {
            // console.log('path======', path)
            if (val) {
                this.$router.push({
                    path: path,
                    query: val,
                });
            } else {
                this.$router.push({
                    path: path,
                });
            }
        },
        downsop1() {
            let href = window.location.origin + '/refs/static/file/SOP.rtf'
            window.open(href, '_blank')
        },
        downsop2() {
            let href = window.location.origin + '/refs/static/file/WDCM_Proce_ures.rtf'
            window.open(href, '_blank')
        },
    },
};
</script>
<style lang='less'>
.fd-nav {
    background: #237D3F !important;
    box-shadow: 0px 1px 0px 0px rgba(255,255,255,0.2);

    .fd-nav-content {
        width: 1200px;
        margin: 0 auto;
        .icon {
            margin-right: 6px;
        }

        .active {
            border-bottom: 2px solid #1451E5;
        }

        .el-menu {
            background: #237D3F !important;
            color: #FFFFFF;
            font-size: 16px;
        }

        // 导航下边线
        .el-menu.el-menu--horizontal {
            border-bottom: none !important;
        }

        // item hover效果
        .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
        .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
        .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
            background-color: #64A93E !important;
            color: #FFFFFF !important;
        }

        .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
            border-bottom: none !important;
            background-color: #64A93E !important;
        }

        // 字体颜色
        .el-menu--horizontal>.el-submenu .el-submenu__title {
            color: #FFFFFF !important;
            line-height: 46px !important;
            height: 46px !important;
            padding: 0 18px;
        }

        // hover字体颜色
        .el-menu--horizontal>.el-submenu:focus .el-submenu__title,
        .el-menu--horizontal>.el-submenu:hover .el-submenu__title {
            color: #FFFFFF !important;
        }

        // 选中颜色
        .el-menu--horizontal>.el-menu-item.is-active {
            color: #FFFFFF !important;
            border-bottom: none !important;
            font-weight: bold;
            background-color: #64A93E;
        }

        // icon 颜色
        .el-submenu__title i {
            color: #FFFFFF !important;
        }

        .el-menu--horizontal>.el-menu-item {
            color: #FFFFFF !important;
        }

        .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
            margin-left: 5px !important;
            margin-top: 0px !important;
        }

        .el-menu-item:hover {
            background: #64A93E;
        }

        .el-menu--horizontal>.el-menu-item {
            padding: 0;
            line-height: 46px;
            height: 46px;
            padding: 0 18px;
        }

        .el-menu--horizontal>.el-menu-item:first-child {
            margin-left: 0;
        }

        // .el-submenu__title {
        //     padding: 0;
        //     // margin-left: 20px;
        //     line-height: 46px;
        //     height: 46px;
        //     padding: 0 18px;
        // }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/navmenu.vue